import React, { useState } from "react"
import axios from "axios"
import { documentToReactComponents } from "@contentful/rich-text-react-renderer"
import clsx from "clsx"

import { apiStatuses, loadingStatuses } from "../../utils/constants"

import GrayTick from "../../images/tick-gray.svg"
import RedCross from "../../images/cross-red.svg"

import "../../styles/components/_dnsForm.scss"

const StatusMessage = ({ Icon, message, className }) => (
  <div className={clsx("msg-container", className)}>
    <Icon className="svg" />
    <span className="message">{message}</span>
  </div>
)

const DoNotSellForm = ({ formData: { description, placeholder, ctaText } }) => {
  const [apiStatus, setApiStatus] = useState("")
  const [email, setEmail] = useState("")
  const [loading, setLoading] = useState(loadingStatuses.idle)

  const handleChange = event => {
    setEmail(event.target.value)
  }

  const handleSubmit = async e => {
    e.preventDefault()

    // Reset the previous status when someone submits again
    setApiStatus("")

    setLoading(loadingStatuses.loading)

    try {
      await axios.post(
        "/v2/msg/transactional/do-not-sell",
        {
          email_address: email,
          site_domain: window.location.hostname,
        },
        {
          baseURL: `https://${process.env.GATSBY_API_HOST ??
            "api.talentinc.com"}`,
        }
      )

      setApiStatus(apiStatuses.success)
    } catch (_) {
      setApiStatus(apiStatuses.failure)
    } finally {
      setEmail("")
      setLoading(loadingStatuses.idle)
    }
  }

  return (
    <div className="dns">
      {documentToReactComponents(description)}
      <form className="form" onSubmit={handleSubmit}>
        <input
          type="email"
          aria-label={placeholder}
          placeholder={placeholder}
          className="input"
          value={email}
          onChange={handleChange}
          required
        />

        <button
          aria-label="submit"
          type="submit"
          className="cta"
          // disabled
          disabled={loading === loadingStatuses.loading}
        >
          {ctaText}
        </button>
      </form>
      {apiStatus === apiStatuses.success && (
        <StatusMessage
          Icon={GrayTick}
          message="Your request has been submitted"
          className="success-container"
        />
      )}
      {apiStatus === apiStatuses.failure && (
        <StatusMessage
          Icon={RedCross}
          message="Your request failed to submit, please try again"
          className="failure-container"
        />
      )}
    </div>
  )
}

export default DoNotSellForm
